module.exports = __webpack_public_path__ + "assets/img/amplification.ad818fcd.svg";